export default __webpack_public_path__ + "static/media/ic_library_books.dfd2a5a7.svg";